import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";
import {LogoMetadataModel} from "./logo.metadata-model";
import {IMAGE_DEFAULT_FORMATS} from "../../../app/consts";

export class LogoImageParams extends ImageRequestParams {
  constructor(metaData: LogoMetadataModel, width, height, ratio) {
    super({resourceName: `WebSite/logo_new`, metaData});

    this.c = '';
    this.ratio = ratio;
    this.version = 2;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}
